import React from 'react';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useOnboarding } from '@sde/widgets-core/src/redux/resources/onboarding';

import { styled } from '@uhg-abyss/web/tools/styled';
import { useModal } from 'src/state/modal';
import { NavMenu } from '@uhg-abyss/web/ui/NavMenu';

const StyledNavMenuItem = styled(NavMenu.Item, {
  static: {
    font: 'strong',
    '&.abyss-nav-menu-link-root': {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
    },
    '&.abyss-nav-menu-link': {
      height: 'inherit',
      minHeight: 'inherit',
      alignItems: 'flex-start !important',
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
    },
  },

  dynamic: ({ isDisabled }) => {
    return {
      color: !isDisabled ? '$interactive1' : '$gray5',

      '&:hover': {
        backgroundColor: !isDisabled && '$gray2',
        color: !isDisabled ? '$interactive1' : '$gray5',
      },
    };
  },
});

export const ReactivateTrainingTips = () => {
  const { user } = useUser.state();
  const { tooltips } = useOnboarding.state();
  const isDisabled = Object.values(tooltips).every((isActive) => isActive);
  const { toggleModal } = useModal.actions();

  const openReactivateTrainingTipModal = () => {
    toggleModal({
      key: 'training-modal',
      isOpen: true,
    });
  };

  if (Object.values(tooltips).length === 0) {
    return null;
  }

  return (
    <StyledNavMenuItem
      onClick={openReactivateTrainingTipModal}
      isDisabled={user.isTechnicalUser || isDisabled}
      href=""
      id="reactivate-training-tips"
      title="Reactivate Training Tips"
    />
  );
};
